import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-image-with-text',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './image-with-text.component.html',
    styleUrl: './image-with-text.component.css'
})
export class ImageWithTextComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
}
